import { gql } from '@apollo/client';

export const GET_LEGAL_PERSON_REFERENCE = gql`
    query AllLegalPersonReference {
        allLegalPersonReference {
            id
            corporateName
            corporateNumber
            applicantName
            legalPersonReference_verificationId
            legalPersonReference_verificationPublicId
            legalPersonReference_receivedDate
            legalPersonReference_updatedDate
            legalPersonReference_verificationDate
            legalPersonReference_status
            legalPersonReference_result
            legalPersonReference_reasonCode
            legalPersonReference_reasonTarget
            legalPersonReference_reasonDetailFields
            legalPersonReference_verificationMemo
            amlRiskCheck_amlRiskCheckId
            amlRiskCheck_status
            amlRiskCheck_result
            amlRiskCheck_resultType
            amlRiskCheck_resultMatches
            amlRiskCheck_countFound
            amlRiskCheck_createdDate
            amlRiskCheck_completedDate
            amlRiskCheck_updatedDate
        }
    }`;
